import { render } from "./DescriptionUs.vue?vue&type=template&id=4bfe7a96"
import script from "./DescriptionUs.vue?vue&type=script&lang=js"
export * from "./DescriptionUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__